<template>
    <div ref="scrollTarget"></div>
    <div class="container-fluid" style="height: 100%;">
        <div class="row">

            <main class="col-md-12" style=" background-color: #F7F7F8;">

                <div class="row justify-content-center" style="margin-top: 20px; margin-bottom: 100px;">
                    <div class="col-12 text-center">
                        <div class="mb-3" style="max-width: 500px; margin: 0 auto 15px auto;">
                            <input
                                type="text"
                                class="form-control"
                                v-model="filters.search"
                                placeholder="Search by ID, facturation number, or company"
                            />
                        </div>
                        <template v-if="filteredItems.length">
                            <div class="table-responsive-lg">
                                <table class="table table-hover table-striped table-bordered table-responsive">
                                    <thead class="table-dark">
                                        <tr>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-left-radius: 12px;">
                                                ID</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                                                Created at</th>
                                                <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Company</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                                                Shipments</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                                                Facturation number</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff">
                                                Commissions</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Cash payments</th>
                                            <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Additional cash</th>
                                                <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Total</th>
                                                <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff;">
                                                Status</th>
                                                <th
                                                style="vertical-align: middle; text-align: center; color: white; background-color: #E5097F; border: 1px solid #fff; border-top-right-radius: 12px;">
                                                Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in filteredItems" :key="row.id">
                                            <td style="vertical-align: middle; text-align: center; "> {{ row.id }}</td>
                                            <td style="vertical-align: middle; text-align: center; "> {{ row.created_at
                                            }}
                                            </td>
                                            <td style="vertical-align: middle; text-align: center; "> {{ row.servicepoint }}
                                            </td>
                                            <td style="vertical-align: middle; text-align: center; "> {{ row.shipments }}</td>
                                            <td style="vertical-align: middle; text-align: center;"> {{ row.facturation_number }}</td>
                                            <td style="vertical-align: middle; text-align: center;"> {{ row.commissions_amount }}
                                            </td>
                                            <td style="vertical-align: middle; text-align: center;"> {{ row.cashpayments_amount }}</td>
                                            <td style="vertical-align: middle; text-align: center;"> {{ row.additionalcash_amount }}</td>
                                            <td style="vertical-align: middle; text-align: center;"> {{ row.total }}</td>
                                            <td :class="{ 'green-class': row.is_paid, 'red-class': !row.is_paid }" style="vertical-align: middle; text-align: center;"> {{ row.is_paid ? 'Paid' : 'No Paid' }}</td>
                                            <td
                                                style="vertical-align: middle; text-align: center; color: #E5097F; cursor: pointer; text-decoration: underline;">
                                                <span @click="selectShipment(row)">{{ translate('see_details') }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template v-else>
                            <div class="container"
                                style="text-align: center; color: white; font-weight: bold; font-size: 1.5em; background-color: #F1A8D0; padding: 60px; border-radius: 20px;">
                                {{ translate('no_orders') }}
                            </div>
                        </template>

                        <div v-if="selectedShipment" class="modal">
                            <div class="modal-content">
                                <span style="text-align: right;" @click="closeModal" class="close">&times;</span>
                                <div style="text-align: center;">
                                    <p style="color: #E5097F;"><strong style="color: #E5097F;">Auto facturation id :</strong>
                                        {{ selectedShipment.id }}</p>
                                </div>
                                <div class="modal-body">
                                    <div class="column">
                                        <p>
                                        <div class="row">
                                            <div class="col">
                                                <label class="label-control"
                                                    style="color: black; font-weight: 600; margin-bottom: 5px;">Facturation number</label>
                                                <input type="text" class="form-control" placeholder="Facturation number"
                                                    v-model="selectedShipment.facturation_number">
                                            </div>
                                        </div>
                                        </p>
                                        <br>
                                        <p>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                v-model="selectedShipment.is_paid" id="flexCheckAutoFact">
                                            <label class="form-check-label" for="flexCheckAutoFact">
                                                Paid
                                            </label>
                                        </div>
                                        </p>
                                    </div>
                                    <div class="column">
                                        <p></p>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn btn-success" style="width: 200px;"
                                        @click="modifyUser(selectedShipment.id)">Edit information</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>
      
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';


export default {
    name: 'AutoFacturations',
    mixins: [en, fr, nl],
    data() {
        return {
            user: {},
            users: [],
            selectedShipment: null,
            filters: {
                search: ""
            }
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang || 'en'
        },
        filteredItems() {
            const term = (this.filters.search || "").toLowerCase();
            if (!term) {
                return this.users;
            }
            return this.users.filter((row) => {
                const text = [
                    row.id,
                    row.facturation_number,
                    row.servicepoint,
                    row.shipments,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();
                return text.includes(term);
            });
        },
    },
    async created() {

        this.$store.commit('setIsLoading', true)
        await axios.get('/api/v1/users/me/')
            .then(async response => {
                this.user = response.data
            })
            .catch(error => {
                console.log(error)
            })
        this.$store.commit('setIsLoading', false)
    },
    async mounted() {
        document.title = 'Auto facturations | Admin';
        const element = this.$refs.scrollTarget;
        element.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo(0, 0);

        this.$store.commit('setIsLoading', true)
        await this.fetchRows()
        this.$store.commit('setIsLoading', false)

    },
    methods: {
        translate(prop) {
            const currentLang = this.lang || 'en';
            const dict = this[currentLang] || this.en || {};
            return dict[prop] || '';
        },
        async fetchRows() {
            try {
                const response = await axios.post('/api/v1/admin/get-autofacturations-v2/');
                this.users = response.data['autofacturations'];
            } catch (error) {
                console.error('Error fetching auto facturations:', error);
            }
        },
        selectShipment(shipment) {
            this.selectedShipment = shipment;
        },
        closeModal() {
            this.selectedShipment = null;
            this.fetchRows()
        },
        modifyUser(user_id) {
            Swal.fire({
                icon: 'question',
                title: 'Edit auto facturation',
                text: 'Are you sure you want to edit ?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                confirmButtonColor: '#4BB543',
                cancelButtonColor: '#ff0e0e',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.editUser(user_id)
                }
            });
        },
        async editUser(user_id) {
            const arra = this.users.filter((user) => user.id === user_id)
            const user_selected = arra[0]
            const formData = {
                facturation_number: user_selected.facturation_number,
                is_paid: user_selected.is_paid,
            }
            this.$store.commit('setIsLoading', true)
            await axios
                .post(`/api/v1/admin/edit-autofacturation-v2-details/${user_id}/`, formData)
                .then(response => {

                    this.fetchRows();
                    this.closeModal();
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                })
            this.$store.commit('setIsLoading', false)
        }
    }
}
</script>
      
<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    color: black;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-body {
    display: flex;
    justify-content: space-between;
}

.column {
    width: 50%;
    text-align: left;
}

.modal-content {
    background-color: #FEEEF6;
    margin: 10% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 70%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.green-class{
    background-color: #13c810;
    color: white;
}
.red-class{
    background-color: #F44336;
    color: white;
}
</style>
